/* AppTile.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _54 = "._1n261g80{flex-wrap:wrap}";
const _53 = "._4cvresu3{align-items:flex-end}";
const _52 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _51 = "._1bsb1osq{width:100%}";
const _50 = "._1i4q1hna{overflow-wrap:break-word}";
const _49 = "._k48p1nn1{font-weight:400}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Lozenge from '@atlaskit/lozenge';
import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyNormal, H5, Ratings } from '@atlassian/mpac-primitives';
import { CloudFortifiedStatusValues } from '@atlassian/mpac-types';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import { AppTileHighlightedText } from '@atlassian/mpac-ui';
import { DateUtils, getScaledImage, useMountPath } from '@atlassian/mpac-utils';
import { Link } from 'react-router-dom';
import { getBootstrapLinks } from '../../Config';
import { TEST_IDS } from '../../primitives/testIds';
import { createTileHighlights } from '../../utils/createTileHighlights';
import { CertificationBadge } from '../CertificationBadge/CertificationBadge';
import { InstallDownloadMetrics } from '../InstallDownloadMetrics';
import { PartnerDetails } from '../PartnerDetails/PartnerDetails';
import { AppLogo } from './AppLogo';
import { AppLogoWrapper, AppNameWrapper, AppTileContainer, AppTileHeader, AppTileLink, AppTileMainContentWrapper, Heading, NoCertification, PartnerDetailsWrapper, RatingsAndInstallsContainer, Tagline } from './AppTile.styles';
import { BadgeVariant, Certification } from './AppTile.types';
import { getAppListingUrl } from './AppTile.utils';
import { AppTileBadge } from './AppTileBadge';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _48 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _47 = "._1bto1l2s{text-overflow:ellipsis}";
const _46 = "._vwz41ejb{line-height:var(--ds-space-300,24px)}";
const _45 = "._ect41gqc{font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _44 = "._18m915vq{overflow-y:hidden}";
const _43 = "._1reo15vq{overflow-x:hidden}";
const _42 = "._zulp12x7{gap:var(--ds-space-075,6px)}";
const _41 = "._4cvr1h6o{align-items:center}";
const _40 = "._1bah1h6o{justify-content:center}";
const _39 = "._bfhk18uv{background-color:initial}";
const _38 = "._2rkou2gc{border-radius:var(--ds-space-100,8px)}";
const _37 = "._zulpud5o{gap:.625rem}";
const _36 = "._1yt4v77o{padding:var(--ds-space-025,2px)}";
const _35 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _34 = "._4cvr1y6m{align-items:flex-start}";
const _33 = "._1wpz1fhb{align-self:stretch}";
const _32 = "._180d1cd0:active{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _31 = "._1iohnqa1:active{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _30 = "._c2waglyw:active{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _29 = "._1nrm18uv:active{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _28 = "._j6xt1a0f:active{background:var(--ds-surface-raised-hovered,#f1f2f4)}";
const _27 = "._1dbz1cd0:hover{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _26 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _25 = "._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _24 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _23 = "._1ejj1cd0:focus-visible{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _22 = "._1w0vnqa1:focus-visible{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _21 = "._10xfglyw:focus-visible{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _20 = "._vjfr18uv:focus-visible{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _19 = "._1ygb1a9f:focus-visible{outline:var(--_1kmg6zk)}";
const _18 = "._16qszucj{box-shadow:var(--ds-shadow-raised,0 1px 1px #091e4240,0 0 1px #091e424f)}";
const _17 = "._4t3i1osq{height:100%}";
const _16 = "._p12f1dfx{max-width:32.5rem}";
const _15 = "._1bah1yb4{justify-content:space-between}";
const _14 = "._2lx21bp4{flex-direction:column}";
const _13 = "._1e0c1txw{display:flex}";
const _12 = "._80omtlke{cursor:pointer}";
const _11 = "._kqswh2mm{position:relative}";
const _10 = "._vchhusvi{box-sizing:border-box}";
const _9 = "._19itkxja{border:var(--_1aje98t)}";
const _8 = "._ajmmnqa1{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _7 = "._1hmsglyw{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _6 = "._4bfu18uv{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _5 = "._v56416gf{transition:box-shadow .2s ease-in-out}";
const _4 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _3 = "._11q7vuon{background:var(--ds-surface,#fff)}";
const _2 = "._2rkov47k{border-radius:var(--ds-space-250,20px)}";
const _ = "._1yt41ueu{padding:var(--_gvfnkj)}";
const AppTileContainerStyle = null;
const AppHeaderStyle = null;
const AppContentStyle = null;
const AppTileTitleStyle = null;
const AppNameStyle = null;
const HeadingStyle = null;
const AppIconWrapperStyle = null;
const PartnerDetailsWrapperStyle = null;
const TaglineStyle = null;
const FooterStyle = null;
const RatingsAndInstallContainerStyle = null;

// eslint-disable-next-line max-lines-per-function
export function AppTile(_ref) {
  let {
    tileData,
    environment,
    source,
    hideTagline = false,
    hidePartnerDetails = false,
    onTileClick,
    tileRef,
    isAppInstalled,
    preferredHosting
  } = _ref;
  const {
    enableRunsOnAtlassian,
    enableMediaFromProductListing,
    enableScalingLogicOnUI,
    enableMpacWebCoherence
  } = useStatsig();
  const isRunsOnAtlassianEnabled = enableRunsOnAtlassian();
  const links = getBootstrapLinks(environment);
  const appLogoUrl = getAppLogoUrl();
  const appName = getAppName();
  const tagLine = getTagLine();
  const certification = getCertification();
  const tileBadgeVariant = getTileBadgeVariant();
  const mountPath = useMountPath();
  const {
    downloads,
    activeInstalls: installs,
    bundled
  } = tileData.distribution;
  const partner = tileData.vendor;
  const partnerDetailProps = getPartnerDetailProps();
  function getAppLogoUrl() {
    const imageId = tileData.logo.highRes || tileData.logo.image;
    const {
      width,
      height
    } = tileData.logo;
    if (enableMediaFromProductListing()) {
      const url = links.mediaFileProductListing.expand({
        imageId
      });
      if (width && height && enableScalingLogicOnUI()) {
        const {
          width: scaledWidth,
          height: scaledHeight
        } = getScaledImage(width, height);
        return "".concat(url, "?width=").concat(scaledWidth, "&height=").concat(scaledHeight);
      }
      return url;
    }
    return links.mediaFile.expand({
      imageId
    });
  }
  function getAppName() {
    if (tileData._highlightResult) {
      const highlightedText = createTileHighlights(tileData._highlightResult, 'name', 'tokenizedName');
      return /*#__PURE__*/_jsx(AppTileHighlightedText, {
        highlightedText: highlightedText,
        originalText: tileData.name,
        overrideStyles: {
          color: "var(--ds-text, #172B4D)",
          fontWeight: 700
        }
      });
    } else {
      return tileData.name;
    }
  }
  function getTagLine() {
    if (tileData._highlightResult) {
      const highlightedText = createTileHighlights(tileData._highlightResult, 'tagLine', 'tokenizedTagLine');
      return /*#__PURE__*/_jsx(AppTileHighlightedText, {
        highlightedText: highlightedText,
        originalText: tileData.tagLine,
        overrideStyles: {
          color: "var(--ds-text, #172B4D)",
          fontWeight: 600
        }
      });
    } else {
      return tileData.tagLine;
    }
  }
  function getTileBadgeVariant() {
    var _tileData$tags;
    let badgeVariant;
    const marketingLabels = ((_tileData$tags = tileData.tags) === null || _tileData$tags === void 0 ? void 0 : _tileData$tags.marketingLabels) || [];
    if (marketingLabels.includes('Spotlight')) {
      badgeVariant = BadgeVariant.SPOTLIGHT;
    } else if (marketingLabels.includes('Bestseller')) {
      badgeVariant = BadgeVariant.BESTSELLER;
    } else if (marketingLabels.includes('Rising Star')) {
      badgeVariant = BadgeVariant.RISINGSTAR;
    } else {
      const releaseDate = tileData.releaseDate;
      if (releaseDate) {
        badgeVariant = Math.abs(DateUtils.differenceInDaysToNow(releaseDate)) < 14 ? BadgeVariant.NEW : undefined;
      }
    }
    return badgeVariant;
  }
  function getPartnerDetailProps() {
    var _partner$partnerTier;
    return {
      name: partner.name,
      partnerTier: (_partner$partnerTier = partner.partnerTier) === null || _partner$partnerTier === void 0 ? void 0 : _partner$partnerTier.type.toUpperCase()
    };
  }
  function getCertification() {
    var _tileData$programs, _tileData$programs$cl, _tileData$programs2, _tileData$programs3, _tileData$programs3$r;
    const isCloudFortifiedApp = ((_tileData$programs = tileData.programs) === null || _tileData$programs === void 0 ? void 0 : (_tileData$programs$cl = _tileData$programs.cloudFortified) === null || _tileData$programs$cl === void 0 ? void 0 : _tileData$programs$cl.status) === CloudFortifiedStatusValues.Approved;
    const isCloudSecurityParticipantApp = isBugBountyParticipant(AtlassianProductHostingType.Cloud, (_tileData$programs2 = tileData.programs) === null || _tileData$programs2 === void 0 ? void 0 : _tileData$programs2.bugBountyParticipant) && tileData.deployments.includes('cloud');
    const isRunsOnAtlassianApp = isRunsOnAtlassianEnabled && ((_tileData$programs3 = tileData.programs) === null || _tileData$programs3 === void 0 ? void 0 : (_tileData$programs3$r = _tileData$programs3.runsOnAtlassian) === null || _tileData$programs3$r === void 0 ? void 0 : _tileData$programs3$r.status);
    let certificationType;
    if (isRunsOnAtlassianApp) {
      certificationType = Certification.RUNS_ON_ATLASSIAN;
    } else if (isCloudFortifiedApp) {
      certificationType = Certification.CLOUD_FORTIFIED;
    } else if (isCloudSecurityParticipantApp) {
      certificationType = Certification.CLOUD_SECURITY_PARTICIPANT;
    }
    return certificationType;
  }
  function onTileClickHandler(e) {
    e.stopPropagation();
    onTileClick === null || onTileClick === void 0 ? void 0 : onTileClick(tileData);
  }
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32]
      }), /*#__PURE__*/_jsxs(Link, {
        to: getAppListingUrl(source, tileData, mountPath, preferredHosting),
        onClick: onTileClickHandler,
        "data-testId": TEST_IDS.APP_TILE,
        innerRef: tileRef,
        className: ax(["_1yt41ueu _2rkov47k _11q7vuon _zulppxbi _v56416gf _4bfu18uv _1hmsglyw _ajmmnqa1 _19itkxja _vchhusvi _kqswh2mm _80omtlke _1e0c1txw _2lx21bp4 _1bah1yb4 _p12f1dfx _4t3i1osq _16qszucj _1ygb1a9f _vjfr18uv _10xfglyw _1w0vnqa1 _1ejj1cd0 _9oik18uv _1bnxglyw _jf4cnqa1 _1dbz1cd0 _j6xt1a0f _1nrm18uv _c2waglyw _1iohnqa1 _180d1cd0"]),
        style: {
          "--_gvfnkj": ix("1.75rem ".concat("var(--ds-space-300, 24px)", " ", "var(--ds-space-300, 24px)", " ", "var(--ds-space-300, 24px)")),
          "--_1aje98t": ix("0.0625rem solid ".concat("var(--ds-border, #091E4224)")),
          "--_1kmg6zk": ix("var(--ds-space-025, 2px)".concat(" solid ", "var(--ds-border-focused, #388BFF)"))
        },
        children: [tileBadgeVariant && /*#__PURE__*/_jsx(AppTileBadge, {
          variant: tileBadgeVariant
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_13, _14, _33, _34, _15]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_1e0c1txw _2lx21bp4 _1wpz1fhb _4cvr1y6m _1bah1yb4"]),
            children: [/*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_35, _13, _14, _33, _34, _15]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4 _1wpz1fhb _4cvr1y6m _1bah1yb4"]),
                children: [/*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_4, _13, _33, _34]
                  }), /*#__PURE__*/_jsxs("div", {
                    className: ax(["_zulppxbi _1e0c1txw _1wpz1fhb _4cvr1y6m"]),
                    children: [/*#__PURE__*/_jsxs(CC, {
                      children: [/*#__PURE__*/_jsx(CS, {
                        children: [_36, _37, _38, _39, _13, _40, _41]
                      }), /*#__PURE__*/_jsx("div", {
                        className: ax(["_1yt4v77o _zulpud5o _2rkou2gc _bfhk18uv _1e0c1txw _1bah1h6o _4cvr1h6o"]),
                        children: /*#__PURE__*/_jsx(AppLogo, {
                          alt: tileData.name,
                          loading: "lazy",
                          src: appLogoUrl,
                          "aria-hidden": "true"
                        })
                      })]
                    }), /*#__PURE__*/_jsxs(CC, {
                      children: [/*#__PURE__*/_jsx(CS, {
                        children: [_42, _13, _14, _33, _34]
                      }), /*#__PURE__*/_jsx("div", {
                        className: ax(["_zulp12x7 _1e0c1txw _2lx21bp4 _1wpz1fhb _4cvr1y6m"]),
                        children: /*#__PURE__*/_jsxs(CC, {
                          children: [/*#__PURE__*/_jsx(CS, {
                            children: [_43, _44, _45, _46, _47]
                          }), /*#__PURE__*/_jsx(H5, {
                            className: ax(["_1reo15vq _18m915vq _ect41gqc _vwz41ejb _1bto1l2s"]),
                            children: appName
                          })]
                        })
                      })]
                    })]
                  })]
                }), !hidePartnerDetails && /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_48, _33, _41]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_zulp1b66 _1wpz1fhb _4cvr1h6o"]),
                    children: /*#__PURE__*/_jsx(PartnerDetails, _objectSpread({}, partnerDetailProps))
                  })]
                })]
              })]
            }), !hideTagline && /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_43, _44, _49, _47, _50, _33, _34, _51, _52]
              }), /*#__PURE__*/_jsx(BodyNormal, {
                className: ax(["_1reo15vq _18m915vq _k48p1nn1 _1bto1l2s _1i4q1hna _1wpz1fhb _4cvr1y6m _1bsb1osq _19pkpxbi"]),
                children: tagLine
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_35, _13, _33, _14, _15]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_zulpu2gc _1e0c1txw _1wpz1fhb _2lx21bp4 _1bah1yb4"]),
            children: [/*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_13, _33, _53, _54, _15]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_1e0c1txw _1wpz1fhb _4cvresu3 _1n261g80 _1bah1yb4"]),
                children: [/*#__PURE__*/_jsx(Ratings, {
                  isWebCoherenceEnabled: true,
                  testId: TEST_IDS.RATINGS,
                  ratings: tileData.ratings
                }), isAppInstalled !== null && isAppInstalled !== void 0 && isAppInstalled(tileData.addonKey) ? /*#__PURE__*/_jsx(Lozenge, {
                  isBold: true,
                  children: "Added"
                }) : /*#__PURE__*/_jsx(InstallDownloadMetrics, {
                  appName: tileData.name,
                  installs: installs,
                  downloads: downloads,
                  isPreinstalled: bundled,
                  isWebCoherenceEnabled: true
                })]
              })]
            }), certification ? /*#__PURE__*/_jsx(CertificationBadge, {
              certification: certification
            }) : /*#__PURE__*/_jsx(NoCertification, {})]
          })]
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsx(AppTileContainer, {
    children: /*#__PURE__*/_jsxs(AppTileLink, {
      to: getAppListingUrl(source, tileData, mountPath, preferredHosting),
      onClick: onTileClickHandler,
      "data-testid": TEST_IDS.APP_TILE,
      innerRef: tileRef,
      children: [tileBadgeVariant && /*#__PURE__*/_jsx(AppTileBadge, {
        variant: tileBadgeVariant
      }), /*#__PURE__*/_jsxs(AppTileMainContentWrapper, {
        children: [/*#__PURE__*/_jsxs(AppTileHeader, {
          children: [/*#__PURE__*/_jsx(AppLogoWrapper, {
            children: /*#__PURE__*/_jsx(AppLogo, {
              alt: tileData.name,
              loading: "lazy",
              src: appLogoUrl,
              "aria-hidden": "true"
            })
          }), /*#__PURE__*/_jsx(AppNameWrapper, {
            children: /*#__PURE__*/_jsx(Heading, {
              children: appName
            })
          })]
        }), !hidePartnerDetails && /*#__PURE__*/_jsx(PartnerDetailsWrapper, {
          children: /*#__PURE__*/_jsx(PartnerDetails, _objectSpread({}, partnerDetailProps))
        }), !hideTagline && /*#__PURE__*/_jsx(Tagline, {
          children: tagLine
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(RatingsAndInstallsContainer, {
          children: [/*#__PURE__*/_jsx(Ratings, {
            testId: TEST_IDS.RATINGS,
            ratings: tileData.ratings
          }), isAppInstalled !== null && isAppInstalled !== void 0 && isAppInstalled(tileData.addonKey) ? /*#__PURE__*/_jsx(Lozenge, {
            isBold: true,
            children: "Added"
          }) : /*#__PURE__*/_jsx(InstallDownloadMetrics, {
            appName: tileData.name,
            installs: installs,
            downloads: downloads,
            isPreinstalled: bundled,
            isWebCoherenceEnabled: false
          })]
        }), certification ? /*#__PURE__*/_jsx(CertificationBadge, {
          certification: certification
        }) : /*#__PURE__*/_jsx(NoCertification, {})]
      })]
    })
  });
}